import { graphql } from "api/cms-website/generated";

import { ButtonFragment } from "../primitives/button";
import { SliderItemFragment } from "../elements/sliderItem";

export const SliderFragment = graphql(/* GraphQL */ `
    fragment SliderFragment on ComponentComponentsSlider {
        id
        noMarginBottom
        sliderTitle: title
        sliderCta: cta {
            ...ButtonFragment
        }
        sliderItems: items {
            ...SliderItemFragment
        }
        sliderTrustpilotLink: trustpilotLink
        disclaimer
    }
    ${ButtonFragment}
    ${SliderItemFragment}
`);
